import { configureStore, combineReducers } from '@reduxjs/toolkit';
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web

import instituteConfigReducer from '../features/instituteConfig';
import currentUserReducer from '../features/currentUser';
import checkAccessReducer from '../features/checkAccess';
import languageReducer from '../features/languageReducer';
import actionKeyReducer from '../features/actionKey';
import settingsReducer from '../features/settingsReducer';
import chatUnreadReducer from '../features/chatUnread';
import menuListReducer from '../features/menuList';

// Combine all reducers
const rootReducer = combineReducers({
  instituteConfig: instituteConfigReducer,
  currentUser: currentUserReducer,
  userAccess: checkAccessReducer,
  language: languageReducer,
  actionKey: actionKeyReducer,
  settings: settingsReducer,
  chatUnread: chatUnreadReducer,
  menuList: menuListReducer
});

// Persist configuration
const persistConfig = {
  key: 'root',
  storage,
  whitelist: [],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

// Configure store with middleware for redux-persist
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);